import React from 'react';
import AvatarGroup from '@atlaskit/avatar-group';
export var CollaboratorList = function (_a) {
    var items = _a.items, _b = _a.handleAvatarClick, handleAvatarClick = _b === void 0 ? function () { } : _b, _c = _a.handleMoreAvatarsClick, handleMoreAvatarsClick = _c === void 0 ? function () { } : _c;
    if (items.length === 0) {
        return null;
    }
    return (React.createElement(AvatarGroup, { maxCount: 4, appearance: "stack", size: "small", data: items, onAvatarClick: function (avatarClick) {
            avatarClick.event.stopPropagation();
            avatarClick.event.preventDefault();
            handleAvatarClick(avatarClick);
        }, onMoreClick: function (event) {
            event.stopPropagation();
            event.preventDefault();
            handleMoreAvatarsClick(event);
        } }));
};
//# sourceMappingURL=CollaboratorList.js.map